import React, { Fragment, useContext, useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CardContext from "../../context/card/CardContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import AuthContext from "../../context/auth/AuthContext";
// import ConfigContext from "../../context/config/ConfigContext";
import AlertContext from "../../context/alert/AlertContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import Moment from "react-moment";
import "moment-timezone";
import moment from "moment";
import useTokenCheck from "../../hooks/useTokenCheck";
import usePageTitle from "../../hooks/usePageTitle";
import { env } from "../../env";

const CardDetail = (props) => {
  const cardContext = useContext(CardContext);
  const {
    isLoading,
    selectedCard,
    setCurrentCard,
    modifySubscription,
    modifyRecharge,
  } = cardContext;
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  // const configContext = useContext(ConfigContext);
  // const { getConfigValue } = configContext;
  const alertContext = useContext(AlertContext);
  const navigationContext = useContext(NavigationContext);
  const { clearAlerts } = alertContext;
  const { setNavigationPage } = navigationContext;
  const [card, setCard] = useState();
  const history = useHistory();

  const backToHome = () => {
    setNavigationPage("Recharge");
    history.goBack();
  };
  const { hasTokenExpired } = useTokenCheck();
  const selectCurrentCard = async (e, contract) => {
    e.preventDefault();
    await hasTokenExpired();
    console.log("%%SELECTED Card:", card);
    setCurrentCard(card);
    if (e.target.disabled) return true;
    if (e.target.name === "subscribe") {
      // if (e.target.value === "MANAGE SUBSCRIPTION") {
      //   console.log("Modify subsctiption:", contract);
      //   modifySubscription(contract);
      // }
      console.log("Modify subsctiption:", contract);
      modifySubscription(contract);
      setNavigationPage("Subscribe");
      history.push("/single-subscribe");
    } else if (e.target.name === "recharge") {
      modifyRecharge(contract);
      setNavigationPage("Recharge");
      history.push("/recharge/individual");
    }
  };

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Card Details",
  });

  useEffect(() => {
    clearAlerts();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedCard) {
      localStorage.setItem("selectedCard", JSON.stringify(selectedCard));
      setCard(selectedCard);
    } else {
      const c = localStorage.getItem("selectedCard");
      setCard(JSON.parse(c));
    }
  }, [selectedCard]);
  // console.log("Card Contracts: ", card.contracts);
  return (
    <Fragment>
      {isLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronHome"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 id="pageHeader" className="pageTitle patronHome__pageTitle">
          METRO Q CARD® DETAILS
        </h1>
        <div className="CardItem">
          <Row>
            <Col className="CardItem__cardTitle">
              <h2>{card?.profileName}</h2>
            </Col>
          </Row>
          <Row className="CardItem__cardTitle__cardItems">
            <Col lg={12}>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5"> Serial Number:</Col>
                <Col>
                  <strong>{card?.serialNumber}</strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5"> Metro Q Card® Holder:</Col>
                <Col>
                  <strong>{card?.profileName}</strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5">Contract: </Col>
                <Col>
                  <strong>{card?.contracts[0]?.contractName}</strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5">Card Status:</Col>
                <Col>
                  <strong>{card?.status}</strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5">Created Date/Time: </Col>
                <Col>
                  <strong>
                    <Moment
                      format="MM/DD/YYYY hh:mm A"
                      tz={env.REACT_APP_HMW_TIME_ZONE}
                    >
                      {card?.emissionDate}
                    </Moment>
                  </strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5">Expiration Date: </Col>
                <Col>
                  <strong>
                    <Moment
                      format="MM/DD/YYYY hh:mm A"
                      tz={env.REACT_APP_HMW_TIME_ZONE}
                    >
                      {card?.expirationDate}
                    </Moment>
                  </strong>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        {card?.contracts &&
          card?.contracts?.map((contract) => (
            <Fragment>
              <div key={contract?.id} className="CardItem">
                <Row>
                  <Col className="CardItem__cardTitle">
                    <h2>{contract?.contractName}</h2>
                  </Col>
                </Row>
                <Row className="CardItem__cardTitle__cardItems">
                  <Col lg={12}>
                    <Row className="CardItem__cardTitle__lineItem">
                      <Col lg="5"> Contract Type: </Col>
                      <Col lg="5">
                        <strong>
                          {contract?.family + ":" + contract?.typeOfContract}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="CardItem__cardTitle__lineItem">
                      <Col lg="5">Created Date/Time: </Col>
                      <Col lg="5">
                        <strong>
                          <Moment
                            format="MM/DD/YYYY hh:mm A"
                            tz={env.REACT_APP_HMW_TIME_ZONE}
                          >
                            {contract?.emission}
                          </Moment>
                        </strong>
                      </Col>
                    </Row>
                    <Row className="CardItem__cardTitle__lineItem">
                      <Col lg="5">Last Reload Date/Time:</Col>
                      <Col lg="5">
                        {moment
                          .utc(card?.contracts[0]?.lastReload)
                          .isBefore("0001-01-01") ? (
                          ""
                        ) : (
                          <strong>
                            <Moment
                              format="MM/DD/YYYY hh:mm A"
                              tz={env.REACT_APP_HMW_TIME_ZONE}
                            >
                              {contract?.lastReload}
                            </Moment>
                          </strong>
                        )}
                      </Col>
                    </Row>
                    <Row className="CardItem__cardTitle__lineItem">
                      <Col lg="5"> Card Balance:</Col>
                      <Col lg="5">
                        <strong>
                          $
                          {(contract?.unitsLeft
                            ? contract?.unitsLeft / 100
                            : 0
                          ).toFixed(2)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="CardItem__cardTitle__lineItem">
                      <Col lg="5">Reloadable:</Col>
                      <Col lg="3">
                        <strong>
                          {contract?.rechargeable
                            ? "Yes"
                            : contract?.rechargeReason}
                        </strong>{" "}
                      </Col>

                      <Col lg="4" className="CardDetail__cardActions">
                        {!(user.sponsor && contract?.rideSponsorContract) && (
                          <button
                            name="recharge"
                            className={
                              contract?.rechargeable
                                ? "CardDetail__cardActions__action btn btn-primary"
                                : "CardDetail__cardActions__action btn btn-disabled"
                            }
                            onClick={(e) => selectCurrentCard(e, contract)}
                            disabled={!contract?.rechargeable}
                          >
                            Reload
                          </button>
                        )}
                      </Col>
                    </Row>
                    <Row className="CardItem__cardTitle__lineItem__start">
                      <Col lg="5">Auto Load (Subscription):</Col>
                      <Col lg="3">
                        {/* <strong>{contract.subscriptionInfo.state}</strong>{" "} */}
                        <strong>
                          {contract?.subscriptionAvailable
                            ? "Yes"
                            : contract?.subscriptionReason}
                        </strong>
                      </Col>
                      <Col lg="4" className="CardDetail__cardActions">
                        {!(user.sponsor && contract?.rideSponsorContract) && (
                          <button
                            name="subscribe"
                            className={
                              contract?.subscriptionAllowed ||
                              contract?.subscriptionInfo?.state === "Active"
                                ? "CardDetail__cardActions__actionn btn btn-primary"
                                : "CardDetail__cardActions__action btn btn-disabled"
                            }
                            onClick={(e) => selectCurrentCard(e, contract)}
                            disabled={
                              !(
                                (contract?.subscriptionAllowed ||
                                  contract?.subscriptionInfo?.state ===
                                    "Active") &&
                                !contract?.rideSponsorContract
                              )
                            }
                          >
                            {contract?.subscriptionInfo?.state ===
                            "NoSubscription"
                              ? "ADD SUBSCRIPTION"
                              : "MANAGE SUBSCRIPTION"}
                          </button>
                        )}
                      </Col>
                    </Row>
                    {contract?.subscriptionAvailable && (
                      <Row className="CardItem__cardTitle__lineItem">
                        <Col lg="2">Threshold Amount:</Col>
                        <Col lg="3">
                          <strong>
                            $
                            {(contract?.subscriptionInfo?.trigger?.threshold
                              ? contract?.subscriptionInfo?.trigger?.threshold /
                                100
                              : 0
                            ).toFixed(2)}
                          </strong>
                        </Col>

                        <Col lg="2">Reload Amount: </Col>
                        <Col>
                          <strong>
                            $
                            {(contract?.subscriptionInfo?.rechargeValue
                              ?.rechargeValue
                              ? contract?.subscriptionInfo?.rechargeValue
                                  ?.rechargeValue / 100
                              : 0
                            ).toFixed(2)}
                          </strong>
                        </Col>

                        <Col lg="2">Max Reloads:</Col>
                        <Col>
                          <strong>
                            {
                              contract?.subscriptionInfo
                                ?.maxNumberOfRechargesPerPeriod
                            }
                          </strong>{" "}
                          per month
                        </Col>
                      </Row>
                      // <div>
                      //   <Row>
                      //     <Col lg="5">Threshold Amount:</Col>
                      //     <Col lg="3">
                      //       <strong>
                      //         $
                      //         {(
                      //           contract.subscriptionInfo?.trigger?.threshold /
                      //           100
                      //         ).toFixed(2)}
                      //       </strong>
                      //     </Col>
                      //   </Row>
                      //   <Row>
                      //     <Col lg="5">Recharge Amount: </Col>
                      //     <Col>
                      //       <strong>
                      //         $
                      //         {(
                      //           contract.subscriptionInfo?.rechargeValue
                      //             ?.rechargeValue / 100
                      //         ).toFixed(2)}
                      //       </strong>
                      //     </Col>
                      //   </Row>
                      //   <Row className="CardItem__cardTitle__lineItem">
                      //     <Col lg="5">Max Recharges:</Col>
                      //     <Col>
                      //       <strong>
                      //         {
                      //           contract.subscriptionInfo
                      //             ?.maxNumberOfRechargesPerPeriod
                      //         }
                      //       </strong>{" "}
                      //       per month
                      //     </Col>
                      //   </Row>
                      // </div>
                    )}
                  </Col>
                </Row>

                <div className="CardItemGrid">
                  <div className="CardItemGrid__cardRowTitle">DATE</div>
                  <div className="CardItemGrid__cardRowTitle">
                    ACTIVITY DESCRIPTION
                  </div>
                  <div className="CardItemGrid__cardRowTitle">BILLED</div>
                  <div className="CardItemGrid__cardRowTitle">BEFORE($)</div>
                  <div className="CardItemGrid__cardRowTitle">
                    CHANGE ON CARD
                  </div>
                  <div className="CardItemGrid__cardRowTitle">BALANCE($)</div>
                  {contract.contractActivities &&
                    contract.contractActivities.map((item) => (
                      <Fragment>
                        <div className="CardItemGrid__cardTitle__lineItem">
                          <Moment
                            format="MM/DD/YYYY hh:mm A"
                            tz={env.REACT_APP_HMW_TIME_ZONE}
                          >
                            {item.date}
                          </Moment>
                        </div>
                        <div className="CardItemGrid__cardTitle__lineItem">
                          {item.activityType}
                        </div>
                        <div className="CardItemGrid__cardTitle__lineItem">
                          {" "}
                          ${(item.units / 100).toFixed(2)}{" "}
                        </div>
                        <div className="CardItemGrid__cardTitle__lineItem">
                          {" "}
                          ${(item.unitsBefore / 100).toFixed(2)}{" "}
                        </div>
                        <div className="CardItemGrid__cardTitle__lineItem">
                          ${(item.units / 100).toFixed(2)}
                        </div>
                        <div className="CardItemGrid__cardTitle__lineItem">
                          {" "}
                          ${(item.unitsAfter / 100).toFixed(2)}{" "}
                        </div>
                      </Fragment>
                    ))}
                </div>
              </div>
            </Fragment>
          ))}
        <div id="pageAction" className="patronHome__actionPanel">
          <button
            className="btn btn-primary patronHome__actionPanel__button"
            onClick={backToHome}
            id="backToHome"
            name="backToHome"
          >
            Back
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(CardDetail);
